/* eslint-disable max-lines */
import { useCallback, useMemo } from 'react';

import { mapSeniorityType } from 'services/contacts/seniorityTypes';
import { mapCompanyFundType } from 'services/organizationsV2/organizationFundTypes';

export const useTableRows = ({ network = {}, sharedList, companies, queryParams }) => {
  const formatRow = useCallback(
    (company) => {
      const domain = company.groupIndex ? company.domain : 'exclude';
      const location = company.groupIndex ? company?.locations?.map(({ name }) => name).join(' · ') : 'exclude';
      const industry = company.groupIndex ? company?.industryTags?.join(' · ') : 'exclude';
      const approxEmployees = company.groupIndex ? company.approxEmployees : 'exclude';
      const stage = company.groupIndex ? mapCompanyFundType(company.stage) : 'exclude';
      const yearFounded = company.groupIndex ? company.founded : 'exclude';
      const lists = company.groupIndex ? company.sharedLists?.map((list) => list.name).join(' · ') : 'exclude';

      return {
        getRowHeight: () => 40,
        contactsSource: network.id,
        original: company,
        isGroup: Boolean(company.groupIndex),
        network,
        queryParams,
        sharedList,
        rowId: company.rowId,
        importers: company?.importers ?? [],
        id: company.id,
        name: company.name,
        contactsCount: company.groupIndex ? company.contactsCount : 'exclude',
        contactName: company?.contact?.fullName,
        jobTitle: company?.contact?.targetPositions?.find((position) => position.active)?.jobTitle,
        seniority: mapSeniorityType(company?.contact?.targetPositions?.find((position) => position.active)?.seniority),
        yearsInCompany: Math.round(
          company?.contact?.targetPositions?.reduce((acc, position) => acc + position.duration, 0) || 0,
        ),
        contactOf: company?.contact?.importers ?? [],
        introOffers: company?.introOffers ?? [],
        domain,
        location,
        industry,
        approxEmployees,
        stage,
        yearFounded,
        lists,
      };
    },
    [network, queryParams, sharedList],
  );

  return useMemo(() => companies.map(formatRow), [companies, formatRow]);
};
